import type { LoadPhase } from '../../components/skeletons';

export interface QueryLoadStateInput {
  isFetching: boolean;
  isError: boolean;
  hasData: boolean;
}

/**
 * Standardized load-state mapping for TanStack Query powered screens.
 */
export function getQueryLoadPhase({
  isFetching,
  isError,
  hasData,
}: QueryLoadStateInput): LoadPhase {
  if (isError && !hasData) return 'error';
  if (!isFetching) return 'idle';
  return hasData ? 'refresh' : 'initial';
}

